(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/tickets-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/tickets-wheel.js');
"use strict";


const {
  useEffect,
  useRef,
  useState
} = React;
const TicketCard = svs.eInstant.components.TicketCard;
const TicketsWheel = _ref => {
  let {
    games,
    numberedList,
    onChange
  } = _ref;
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    var _containerRef$current;
    const wrappers = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelectorAll('.slider-item-wrapper');
    if (wrappers && wrappers[activeIndex]) {
      wrappers[activeIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [activeIndex]);
  return React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
    }
  }, React.createElement("div", {
    className: "ticket-card-slider-container u-flex",
    ref: containerRef
  }, games.map((game, index) => React.createElement("label", {
    className: "slider-item-wrapper",
    key: game.id || index
  }, React.createElement("input", {
    "aria-label": "Spel ".concat(index + 1, " av ").concat(games.length),
    checked: activeIndex === index,
    className: "tickets-einstant-ticket-card-radio",
    onChange: () => {
      setActiveIndex(index);
      onChange && onChange(game, index);
    },
    type: "radio"
  }), React.createElement("div", {
    className: index === 0 ? 'margin-h-1' : 'margin-right-1'
  }, React.createElement(TicketCard, {
    hasFocus: activeIndex === index,
    isNumberedList: numberedList,
    number: index + 1,
    ticketConfig: game
  }))))));
};
setGlobal('svs.eInstant.components.TicketsWheel', TicketsWheel);

 })(window);